import React from 'react';
import { Outlet } from 'react-router-dom';

function StorageScene() {
  return <Outlet />;
}

export default StorageScene;
